import * as React from 'react';
import { ReactNode, useEffect } from 'react';

import { SlotFillManager } from '../slot/SlotFillManager';

export interface FillProps {
  slot?: string;
  className?: string;
  children?: ReactNode;
}

const Fill: React.FC<FillProps> = ({ slot, children }) => {
  useEffect(() => {
    if (!slot || !children) return;

    // Register this fill with the slot
    SlotFillManager.registerFill(slot, children);

    return () => {
      // Unregister when component unmounts
      SlotFillManager.unregisterFill(slot, children);
    };
  }, [slot, children]);

  return null;
};

export default Fill;
